import React from "react";
import { Badge, BadgeColor, ensure, Stack } from "sprint-common-web";

export const renderTrailerInfo = <T extends { isTrailer: boolean }>(item?: T): JSX.Element => {
    ensure(item);

    return (
        <Stack style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "6px" }}>
            {!!item.isTrailer && <Badge color={BadgeColor.ApplicationPrimary} text="Trailer" />}
        </Stack>
    );
};
